/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/parameter-properties */
import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import {
  ShopConfigData,
  TSourceConfigSettings,
} from '@/core/apis/config_api/config_api_types';
import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { BrowserInstanceHandler } from '@/core/data_handlers/browser_instance';
import { SessionLogicHandler } from '@/core/data_handlers/session_data/session_logic';
import { StorageHandler } from '@/core/data_handlers/storage_handler';
import { Logger } from '@/shared/logger/logger';
import { EBundleName, ESourceType, ISourceBundle } from '@/sources';
import { LeadFormEventTrigger } from '@/sources/shared/event_triggers/lead_events/form_lead_event';
import { LeadKlaviyoEventTrigger } from '@/sources/shared/event_triggers/lead_events/klaviyo_lead_event';

import { injectSessionIdInLineItems } from './aid_injection/inject_line_items';
import { ShopifyCartAttributeSync } from './aid_injection/inject_note_attributes';
import { ShopifyCartTokenSync } from './token_syncing/sync_cart_token';

export class ShopifySourceBundle implements ISourceBundle {
  name = EBundleName.SHOPIFY_DEFAULT;
  type = ESourceType.SHOPIFY;
  private readonly _storageHandler: StorageHandler<string>;

  constructor(
    public sourceInitConfig: TSourceConfigSettings,
    public wtagFunction: (...args: any[]) => void,
  ) {
    this._storageHandler = new StorageHandler<string>(
      'bundleName',
      this.name,
      EBrowserStorageType.LOCALSTORAGE,
    );
    if (!this._storageHandler.set(this.name))
      Logger.error('Failed to set bundle name in global state');
  }

  sourceInitCallbackFunction(config: ShopConfigData, aid: string, sid: string) {
    if (config.active && sid) {
      if (!config.config.shpy_injectLineItemsDisabled)
        injectSessionIdInLineItems(sid);
      if (!config.config.shpy_injectNoteAttributesDisabled)
        void ShopifyCartAttributeSync.injectNoteAttributes(sid);
      if (!config.config.shpy_cartTokenSyncDisabled && aid)
        void ShopifyCartTokenSync.syncCartAndCheckoutToken(sid);
    }
  }

  initShopifyBundle = () => {
    this.wtagFunction('init', {}, this.sourceInitCallbackFunction.bind(this));
    this.registerEventTriggers();
  };

  init(): void {
    setTimeout(async () => {
      const checkShopConfigAndInit = async (retryCount = 0) => {
        const shopConfig = localStorage.getItem(`${CURR_ENV}_shopConfig`);
        if (shopConfig) {
          if (
            (await SessionLogicHandler.isSessionActive()) &&
            BrowserInstanceHandler.hasIdentity()
          ) {
            this.initShopifyBundle();
          }
        } else if (retryCount < 9) {
          setTimeout(() => checkShopConfigAndInit(retryCount + 1), 100);
        } else {
          this.initShopifyBundle();
        }
      };
      await checkShopConfigAndInit();
    }, 100);
  }

  registerEventTriggers() {
    [LeadKlaviyoEventTrigger, LeadFormEventTrigger].forEach(EventTrigger =>
      new EventTrigger(this.wtagFunction).registerEvent(),
    );
  }
}
